<template>
  <b-card
    no-body
    class="mb-2 shadow-sm border-0 ai-card cluster-card"
    role="region"
    aria-label="Peer health profile clusters"
  >
    <div class="card-body p-3">
      <div class="d-flex align-items-center mb-2">
        <b-icon-people class="mr-2 text-info" font-scale="1.2" aria-hidden="true" />
        <h6 class="m-0 font-weight-bold text-uppercase" style="font-size: 13px;">Peer clusters</h6>
        <b-icon-info-circle class="ml-auto text-muted" v-b-tooltip.hover.html="clusterTooltipHtml" />
      </div>
      <p class="small text-muted mb-2">
        <strong>Avg</strong> is the cluster's mean indicator value; it helps compare cluster performance at a glance.
      </p>
      <div
        v-for="(cluster, index) in clustersData.clusters"
        :key="cluster.id || index"
        class="mb-3 pb-2 border-bottom border-light"
        :class="{ 'mb-0 pb-0 border-0': index === clustersData.clusters.length - 1 }"
      >
        <div class="small font-weight-bold">
          {{ cluster.name }}
          <span class="text-muted font-weight-normal">(avg {{ cluster.average }})</span>
        </div>
        <div
          class="small text-muted mt-1"
          :title="peerTitle(cluster)"
        >
          {{ peerPreview(cluster) }}
        </div>
        <div class="text-right">
          <b-button
            size="sm"
            variant="outline-info"
            class="mt-2"
            :aria-label="'Filter chart to ' + cluster.name + ' peers'"
            @click="onFilter(cluster)"
          >
            Focus peers
          </b-button>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'ClusterCard',
  props: {
    clustersData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    peerPreview(cluster) {
      return (cluster.items || []).map((i) => i.location).join(', ');
    },
    peerTitle(cluster) {
      return (cluster.items || []).map((i) => i.location).join(', ');
    },
    onFilter(cluster) {
      this.$emit('filter-cluster', cluster);
    },
  },
  computed: {
    clusterTooltipHtml() {
      return '<div><strong>What this card does:</strong> groups similar-performing states/zones. Click <em>Focus peers</em> to highlight those areas in the chart.</div>';
    },
  },
};
</script>

<style scoped>
.ai-card {
  cursor: default;
}
.cluster-card {
  border-left: 4px solid #17a2b8 !important;
}
</style>
